import React from "react";
import { Button, Tooltip } from "antd";
import { DataTable } from "./DataTable";
import { YhBox } from "@/components/YhBox";
import { useSoReportModel } from "../soReportModel";
import { YhAuth } from "@/components/auth/YhAuth";
import { IDescription, DescriptionColorEnum } from "@/components/YhBox/Types";
import { ResourceAuthEnum } from "@/types/VrmResoureAuthEnum";
import { disableExportMsg } from "@/utils/exportFile";

export const DataBox = () => {
    const { descTotal, exportSoReport } = useSoReportModel();

    const action = <>
        <YhAuth resCode={ResourceAuthEnum.STT_S_EX}>
            {/* <Tooltip placement="topLeft" title={disableExportMsg}> */}
            <Button
                // disabled={true}
                className="mr-5"
                type="primary"
                shape="round"
                onClick={() => exportSoReport()}
            >导出</Button>
            {/* </Tooltip> */}
        </YhAuth>
    </>;
    const desc: IDescription[] = [
        {
            label: "销售数量",
            value: descTotal.saleNum,
            color: DescriptionColorEnum.red
        },
        {
            label: "销售金额",
            value: descTotal.saleAmount,
            color: DescriptionColorEnum.red
        },
        {
            label: "销售成本",
            value: descTotal.costAmount,
            color: DescriptionColorEnum.red
        },
        {
            label: "销售毛利",
            value: descTotal.profit,
            color: DescriptionColorEnum.red
        },
    ]
    return (
        <YhBox action={action} style={{ height: 'calc(100vh - 180px)' }}>
            <DataTable />
        </YhBox>
    )
}